<template>
<div id="app" class="content-wrapper">
        <div class="ibox-title">
          <h5>详情</h5>
        </div>
          <div class="main_mess">
              <!-- <el-button type="primary"  size="mini" class="back" @click="goBack()">确定</el-button>
              <el-button size="mini" class="back" @click="goBack()">取消</el-button> -->
              <ul>
                  <li class="mess_li">
                      <span class="fileing">身份证号码：</span>
                      <div class="filediv">{{idCard}}</div>
                  </li>
                  <li class="mess_li">
                      <span class="fileing">姓名：</span>
                      <div class="filediv">{{childName}}</div>
                  </li>
                  <li class="mess_li">
                      <span class="fileing">性别：</span>
                      <div class="filediv">{{sex}}</div>
                  </li>
                  <li class="mess_li">
                      <span class="fileing">生日：</span>
                      <div class="filediv">{{birthday}}</div>
                  </li>
                  <li class="mess_li">
                      <span class="fileing">所属幼儿园：</span>
                      <div class="filediv">{{fullName}}</div>
                  </li>
                  <li class="mess_li">
                      <span class="fileing">联系人：</span>
                      <div class="filediv">{{relation}}</div>
                  </li>

                  <li class="mess_li">
                      <span class="fileing">手机号码：</span>
                      <div class="filediv">{{relationPhone}}</div>
                  </li>
                  <li class="mess_li">
                      <span class="fileing">地址：</span>
                      <div class="filediv">{{fullAdd}}</div>
                  </li>
              </ul>
              <!--<el-button class="btn-primary back" @click="goBack()">确定</el-button>-->
          </div>
</div>

</template>
<script>

import { MessageBox, Loading} from 'element-ui'
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件

export default {
  name: 'app',
  data () {
    return {
      idCard: '',
      childName: '',
      sex: '',
      birthday: '',
      fullName: '',
      relation: '',
      relationPhone: '',
      street: '',
      fullAdd: '',
      provinceName: '',
      cityName: '',
      countryName: ''
    }
  },
  methods: {

    goBack () {
      this.$emit('close', false)
    },
    exclude (field) {
      field = (field == undefined) ? (field = '') : field
      return field
    }
  },
  created () {
    //   初始化渲染

    let delList = this.$route.query.list

    if (delList !== undefined && delList !== '') {
      this.idCard = this.exclude(delList.idCard)

      this.childName = this.exclude(delList.childName)

      this.sex = this.exclude(delList.sex)

      this.birthday = this.exclude(delList.birthday)

      this.fullName = this.exclude(delList.fullName)

      this.relation = this.exclude(delList.relation)

      this.relationPhone = this.exclude(delList.relationPhone)

      this.provinceName = this.exclude(delList.provinceName)

      this.cityName = this.exclude(delList.cityName)

      this.countryName = this.exclude(delList.countryName)

      this.street = this.exclude(delList.street)

      this.fullAdd = this.provinceName + this.cityName + this.countryName + this.street
    }
  },
  watch: {
    $route: {
      handler: function (newVal, oldVal) {
        let delList = this.$route.query.list
        if (delList !== undefined && delList !== '') {
          this.idCard = this.exclude(delList.idCard)

          this.childName = this.exclude(delList.childName)

          this.sex = this.exclude(delList.sex)

          this.birthday = this.exclude(delList.birthday)

          this.fullName = this.exclude(delList.fullName)

          this.relation = this.exclude(delList.relation)

          this.relationPhone = this.exclude(delList.relationPhone)

          this.provinceName = this.exclude(delList.provinceName)

          this.cityName = this.exclude(delList.cityName)

          this.countryName = this.exclude(delList.countryName)

          this.street = this.exclude(delList.street)

          this.fullAdd = this.provinceName + this.cityName + this.countryName + this.street
        }
      },
      deep: true
    }
  }
}
</script>

<style>
.main_mess ul{
    overflow:hidden;
    margin-bottom:20px;
    padding-left:0;
}
.nav_cha {
    padding-left: 10px;
    border-left: 5px solid #63a0f0;
    height: 16px;
    line-height: 16px;
    margin: 12px;
    font-weight: bold;
    text-align: left;
}
.mess_li {
    float: left;
    width: 100%;
    margin-left: 30px;
    margin-top: 15px;
    list-style: none;
    text-align: left;
}
.filediv{
    display:inline-block;
}
.fileimg{
   display:block;
   width:200px;
   height:200px;
   margin-left: 76px;
}
.back{
    margin-left: 28px;
    margin-bottom: 20px;
}
.main_mess{
    border-top: 1px solid #ddd;
    padding-top: 14px;
    min-height: 380px;
}
</style>


// WEBPACK FOOTER //
// src/components/childmgr/childsmgrDetail.vue?12f2a942